// Wilderness.js based shape converting tool
// @author @dalisoft

import draw from './draw';
import frame from './frame';
import middleware from './middleware';
import { toPoints } from 'svg-points';
import { autoFix, autoNormalise, moveIndex, reverse, boundingBox } from 'points.js';

function morph (a, b, exportType = 'string') {
  let string = exportType === 'string';
  let canvas = exportType === 'canvas';
  let group = a.type === 'g' && b.type === 'g';

  if (group) {
	let shape = {type: 'g', shapes: []}
	let l = Math.max(a.shapes.length, b.shapes.length)
	for (let i = 0; i < l; i++) {
		let sh1 = a.shapes[i]
		let sh2 = b.shapes[i]

		shape.shapes[i] = morph(sh1, sh2, exportType)
	}
	return shape;
  }

  let p1 = !!a ? toPoints(a) : false
  let p2 = !!b ? toPoints(b) : false

  if (p1 && !p2) {
	const {x, y} = boundingBox(p1).center
	p2 = [{x, y, moveTo: true}, {x, y}]
  } else if (p2 && !p1) {
	const {x, y} = boundingBox(p2).center
	p1 = [{x, y, moveTo: true}, {x, y}]
  }

  let shapes = autoNormalise(p1, p2, {order:'auto'})
  let [ ap, bp ] = autoFix(shapes[0], shapes[1], {order:'auto'})
  let tpv, len = ap.length

  if (a.moveIndex || b.moveIndex) {
	ap = moveIndex(ap, a.moveIndex || b.moveIndex)
  }
  if (a.reverse || b.reverse) {
	ap = reverse(ap)
  }
  
  if (canvas) {
	tpv = ap.map(({x, y, moveTo, curve}) => {
		if (curve) {
			curve = {...curve}
		}
		return {x, y, moveTo, curve}
	});
  }

  return function(t) {
    if (string) {
      let bufferString = ''
	  for (let i = 0; i < len; i++) {
		let {x: xf, y: yf, curve, moveTo} = ap[i]
		let {x: xt, y: yt, curve: curve2} = bp[i]
		let x = xf + (xt - xf) * t
		let y = yf + (yt - yf) * t
		if (moveTo) {
			bufferString += 'M' + x + ',' + y
		} else if (curve && curve2) {
			let { type, x1, y1, x2, y2 } = curve
			let { x1: x3, y1: y3, x2: x4, y2: y4 } = curve2
			if (type === 'cubic') {
				bufferString += 'C' + (x1 + (x3 - x1) * t) + ',' + (y1 + (y3 - y1) * t) + ',' + (x2 + (x4 - x2) * t) + ',' + (y2 + (y4 - y2) * t) + ',' + x + ',' + y
			} else if (type === 'quadratic') {
				bufferString += 'Q' + (x1 + (x3 - x1) * t) + ',' + (y1 + (y3 - y1) * t) + ',' + x + ',' + y
			}
		} else {
			bufferString += 'L' + x + ',' + y
		}
	  }
	  return bufferString
    } else if (canvas) {
	  for (let i = 0; i < len; i++) {
		let {x: xf, y: yf, curve} = ap[i]
		let {x: xt, y: yt, curve: curve2} = bp[i]

		let x = xf + (xt - xf) * t
		let y = yf + (yt - yf) * t

		tpv[i].x = x
		tpv[i].y = y

		if (curve && curve2) {
			let { type, x1, y1, x2, y2 } = curve
			let { x1: x3, y1: y3, x2: x4, y2: y4 } = curve2
			if (type === 'cubic') {
				tpv[i].curve.x1 = (x1 + (x3 - x1) * t)
				tpv[i].curve.y1 = (y1 + (y3 - y1) * t)
				tpv[i].curve.x2 = (x2 + (x4 - x2) * t)
				tpv[i].curve.y2 = (y2 + (y4 - y2) * t)
			} else if (type === 'quadratic') {
				tpv[i].curve.x1 = (x1 + (x3 - x1) * t)
				tpv[i].curve.y1 = (y1 + (y3 - y1) * t)
			}
		}
	  }
	  return tpv
    }
  }
};

morph.easing = {
	linear(k) { return k }
};

export default Object.assign(morph, { draw, frame, middleware });